import callSiteMigration from '../utils/call-site-migration';
import getStatus from '../utils/get-status';
import statusWatcher from '../helpers/status-watcher';

const runSiteMigration = async (siteId, options = {}) => {
  if (!siteId) throw new Error('`siteId` should be specified');

  const { onProgress } = options;
  const {
    data: { id, progress },
  } = await callSiteMigration(siteId);

  if (typeof onProgress === 'function') {
    onProgress(progress);
  }

  const statusGetter = (jobId) => () => getStatus(jobId);
  return statusWatcher(statusGetter(id), onProgress);
};
export default runSiteMigration;
